import React from "react";
import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { FOUNDER } from "@/content/site";

const FounderBlock = () => {
  if (!FOUNDER.name) return null;
  return (
    <section className="mt-10 flex flex-col gap-5 sm:flex-row" data-testid="founder-block" aria-labelledby="founder-heading">
      {FOUNDER.photo && (
        <img src={FOUNDER.photo} alt={`${FOUNDER.name}, founder of The Cardlight`} className="h-28 w-28 shrink-0 rounded-full border border-[#D9A441]/40 object-cover" />
      )}
      <div>
        <h2 id="founder-heading" className="font-display text-2xl text-[#E5C365]">Why I built this</h2>
        {FOUNDER.story.map((p) => <p key={p.slice(0, 24)} className="mt-3 leading-relaxed">{p}</p>)}
        <p className="mt-3 text-sm text-[#A3A5B8]">
          — {FOUNDER.name}
          {FOUNDER.profileUrl && (
            <> · <a href={FOUNDER.profileUrl} target="_blank" rel="noopener noreferrer" className="text-[#E5C365] underline underline-offset-4" data-testid="founder-profile-link">{FOUNDER.profileLabel || "Profile"}</a></>
          )}
        </p>
      </div>
    </section>
  );
};

export default function About() {
  usePageMeta({
    title: "About - The Cardlight",
    description: "About The Cardlight, an AI tarot and oracle reading app, and how each reading is written from the cards you draw.",
    path: "/about",
  });
  return (
    <article className="mx-auto max-w-3xl px-5 py-12 text-[#F8F3E6] sm:px-8" data-testid="about-page">
      <h1 className="font-display text-4xl font-semibold sm:text-5xl">About The Cardlight</h1>
      <p className="mt-5 leading-relaxed">
        The Cardlight is an AI tarot and oracle reading app. You write
        the question on your mind, draw from the Whispering Path Tarot or Oracle deck, and get a
        reading built from the exact cards you drew and what you asked.
      </p>
      <FounderBlock />
      <section className="mt-10" aria-labelledby="how-built-heading">
        <h2 id="how-built-heading" className="font-display text-2xl text-[#E5C365]">How a reading is made</h2>
        <p className="mt-3 leading-relaxed">
          The cards are shuffled and drawn at random. Your question, the spread, each card's position,
          and whether it came up reversed are then given to an AI model (Anthropic's Claude), which is
          asked to answer your question directly and never to predict doom or a fixed fate.
        </p>
      </section>
      <p className="mt-10 text-sm text-[#A3A5B8]">
        <Link to="/pricing" className="text-[#E5C365] underline underline-offset-4">See pricing</Link> ·{" "}
        <Link to="/#faq" className="text-[#E5C365] underline underline-offset-4">Read the FAQ</Link>
      </p>
    </article>
  );
}
